import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
} from "../actions/types";

// Check if stored session has exceeded 15 minutes of inactivity
const checkStoredUser = () => {
  try {
    const rawLast = localStorage.getItem("lastActivityTime");
    const rawUser = localStorage.getItem("user");
    if (!rawUser) return null;

    if (rawLast) {
      const diff = Date.now() - parseInt(rawLast, 10);
      if (diff >= 15 * 60 * 1000) {
        localStorage.removeItem("user");
        localStorage.removeItem("lastActivityTime");
        return null;
      }
    }
    return JSON.parse(rawUser);
  } catch (e) {
    return null;
  }
};

const user = checkStoredUser();

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      return state;
  }
}
